<template>
  <div id="app" v-cloak>
    <keep-alive>
      <!-- 需要缓存的视图组件 -->
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <!-- 不需要缓存的视图组件 -->
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>
<script>
export default {
  name: "App",
  created() {},
  methods: {},
};
</script>

<style lang="scss">
@import url("../src/assets/css/reset.css");
#app {
  // max-width: 576px;
  max-width: 576px;
  margin: 0 auto;
  line-height: 0.4rem;
}
html {
  font-size: calc(100vw / 7.5);
}
@media screen and (min-width: 576px) {
  html {
    font-size: calc(576px / 7.5);
  }
}
[v-cloak] {
  display: none;
}
.van-tabbar-item__icon .van-info {
  background: #f9647d;
}
</style>
